<template>
  <div class="componentBox">
    <h2 class="componentTitle">基础信息</h2>
    <Cell :colList="list" :detail="detail" />
  </div>
</template>

<script>
import Cell from './Cell.vue';
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      list: [
        {title: '填报时间',field: 'createTime',},
        {title: '填报人',field: 'userName',},
      ]
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>